var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg07Diamond01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1600px",
    height: "1600px",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 160000 160000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "FontID0",
    horizAdvX: 834,
    fontVariant: "normal",
    fillRule: "nonzero",
    fontWeight: 900
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Gordita Ultra"
  }, /*#__PURE__*/React.createElement("fontFaceSrc", null, /*#__PURE__*/React.createElement("fontFaceName", {
    name: "Gordita-Ultra"
  }))), /*#__PURE__*/React.createElement("missingGlyph", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0z"
  })), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    horizAdvX: 557,
    d: "M476.011 0l0 783.02 -186.002 0 -295.006 -160.002 105 -182.007 138.999 75.0049 0 -516.016 237.009 0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_07_Diamond_01.svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "ARC_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M92149 155958c41950,-6710 70518,-46157 63809,-88107 -6710,-41950 -46157,-70518 -88107,-63809 -41950,6710 -70518,46157 -63809,88107 5250,32822 30987,58559 63809,63809"
  })), /*#__PURE__*/React.createElement("g", {
    id: "CIRCLE_1_"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    cx: 80000,
    cy: 80000,
    r: 80000
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_57_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M72308 138462l15384 0c4249,0 7693,3444 7693,7692 0,4248 -3444,7692 -7693,7692l-15384 0c-4249,0 -7693,-3444 -7693,-7692 0,-4248 3444,-7692 7693,-7692z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_56_"
  }, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "129445,88719 146617,118462 112273,118462 106309,152284 98452,145691 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_55_"
  }, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "125490,88021 141288,115385 109691,115385 104205,146501 96629,140145 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_54_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M92058 136309c2411,1070 4346,2987 5438,5388 2462,5415 67,11799 -5347,14261"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_53_"
  }, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "86169,135385 80000,130208 73831,135385 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_52_"
  }, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "92058,136309 80000,126191 67942,136309 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_51_"
  }, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "63371,140145 55796,146501 50309,115385 18712,115385 34510,88021 10306,67711 39997,56904 34510,25788 64202,36594 80000,9231 95798,36594 125490,25788 120003,56904 149694,67711 125490,88021 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_50_"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    x1: 73831,
    y1: 135385,
    x2: 86169,
    y2: 135385
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_49_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M67851 155958c-3998,-1818 -6491,-5880 -6303,-10267"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_48_"
  }, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "61548,145691 53691,152284 47727,118462 13383,118462 30555,88719 4245,66642 36519,54896 30555,21073 62828,32820 80000,3077 97172,32820 129445,21073 123481,54896 155755,66642 129445,88719 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_47_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M63371 140145c1132,-1684 2716,-3013 4571,-3836"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_46_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "52021,48848 42694,65002 61347,65002 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_45_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "61347,65002 70674,48848 52021,48848 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_44_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "70674,48848 61347,65002 80000,65002 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_43_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "80000,65002 89326,48848 70674,48848 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_42_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "89326,48848 80000,65002 98653,65002 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_41_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "98653,65002 107979,48848 89326,48848 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_40_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "107979,48848 98653,65002 117306,65002 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE_9_"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    x1: 80000,
    y1: 118462,
    x2: 42694,
    y2: 65002
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE_8_"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    x1: 80000,
    y1: 118462,
    x2: 61347,
    y2: 65002
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE_7_"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    x1: 80000,
    y1: 118462,
    x2: 98653,
    y2: 65002
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE_6_"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    x1: 80000,
    y1: 118462,
    x2: 117306,
    y2: 65002
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE_5_"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    x1: 80000,
    y1: 118462,
    x2: 80000,
    y2: 65002
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_39_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "52021,50387 44027,64233 60015,64233 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_38_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "61347,63463 69341,49617 53353,49617 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_37_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "70674,50387 62679,64233 78668,64233 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_36_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "80000,63463 87994,49617 72006,49617 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_35_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "89326,50387 81332,64233 97321,64233 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_34_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "98653,63463 106647,49617 90659,49617 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_33_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "107979,50387 99985,64233 115973,64233 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_32_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "77433,113438 44169,65771 60801,65771 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_31_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "79231,65771 79231,113922 62430,65771 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_30_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "82567,113438 115831,65771 99199,65771 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_29_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "80769,65771 80769,113922 97570,65771 "
  })))), /*#__PURE__*/React.createElement("text", {
    x: 76860,
    y: 150820,
    fill: "black",
    fontWeight: 900,
    fontSize: "13333px",
    fontFamily: "Gordita Ultra"
  }, "1"), /*#__PURE__*/React.createElement("path", {
    fill: "#1B0921",
    d: "M80000 126191l12058 10118c1866,828 3446,2162 4571,3836l7576 6356 5486 -31116 31597 0 -15798 -27364 24204 -20310 -29691 -10807 5487 -31116 -29692 10806 -15798 -27363 -15798 27363 -29692 -10806 5487 31116 -29691 10807 24204 20310 -15798 27364 31597 0 5487 31116 7575 -6356c1132,-1684 2716,-3013 4571,-3836l12058 -10118zm37306 -61189l-37306 53460 -37306 -53460 9327 -16154 18653 0 18652 0 18653 0 9327 16154z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B0921",
    d: "M87692 138462l-15384 0c-4249,0 -7693,3444 -7693,7692 0,4248 3444,7692 7693,7692l15384 0c4249,0 7693,-3444 7693,-7692 0,-4248 -3444,-7692 -7693,-7692zm-4485 1918l0 10440 -3160 0 0 -6880 -1854 1000 -1400 -2427 3934 -2133 2480 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M44027 64233l7994 -13846 7994 13846 -15988 0zm-1333 769l18653 0 -9326 -16154 -9327 16154z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M61347 65002l-18653 0 37306 53460 -18653 -53460zm16086 48436l-33264 -47667 16632 0 16632 47667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M52021 48848l9326 16154 9327 -16154 -18653 0zm9326 14615l-7994 -13846 15988 0 -7994 13846z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M70674 48848l-9327 16154 18653 0 -9326 -16154zm-7995 15385l7995 -13846 7994 13846 -15989 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M80000 65002l-18653 0 18653 53460 0 -53460zm-769 48920l-16801 -48151 16801 0 0 48151z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M70674 48848l9326 16154 9326 -16154 -18652 0zm9326 14615l-7994 -13846 15988 0 -7994 13846z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M80000 65002l0 53460 18653 -53460 -18653 0zm769 48920l0 -48151 16801 0 -16801 48151z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M80000 65002l18653 0 -9327 -16154 -9326 16154zm1332 -769l7994 -13846 7995 13846 -15989 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M89326 48848l9327 16154 9326 -16154 -18653 0zm1333 769l15988 0 -7994 13846 -7994 -13846z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M107979 48848l-9326 16154 18653 0 -9327 -16154zm-7994 15385l7994 -13846 7994 13846 -15988 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M117306 65002l-18653 0 -18653 53460 37306 -53460zm-34739 48436l16632 -47667 16632 0 -33264 47667z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "77433,113438 60801,65771 44169,65771 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "44027,64233 60015,64233 52021,50387 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "53353,49617 61347,63463 69341,49617 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "79231,65771 62430,65771 79231,113922 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "62679,64233 78668,64233 70674,50387 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "72006,49617 80000,63463 87994,49617 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "80769,65771 80769,113922 97570,65771 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "81332,64233 97321,64233 89326,50387 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "99199,65771 82567,113438 115831,65771 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "99985,64233 115973,64233 107979,50387 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "98653,63463 106647,49617 90659,49617 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8933D4",
    d: "M62828 32820l17172 -29743 17172 29743 32274 -11747c-16495,-13830 -38671,-20697 -61595,-17031 -41950,6710 -70518,46157 -63809,88107 5250,32822 30987,58559 63809,63809 -3998,-1818 -6491,-5880 -6303,-10267l-7857 6593 -5964 -33822 -34344 0 17172 -29743 -26310 -22077 32274 -11746 -5964 -33823 32273 11747z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8933D4",
    d: "M112273 118462l-5964 33822 -7854 -6591c180,4256 -2190,8394 -6306,10265 41950,-6710 70518,-46157 63809,-88107 -65,-404 -132,-807 -203,-1209l-26310 22077 17172 29743 -34344 0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8933D4",
    points: "86169,135385 80000,130208 73831,135385 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8933D4",
    d: "M123481 54896l32274 11746c-3257,-18507 -12909,-34335 -26310,-45569l-5964 33823z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#270545",
    stroke: "#0B0F8A",
    strokeWidth: 1200,
    strokeMiterlimit: 22.9256,
    d: "M96629 140145c-1125,-1674 -2705,-3008 -4571,-3836l-12058 -10118 -12058 10118c-1855,823 -3439,2152 -4571,3836l-7575 6356 -5487 -31116 -31597 0 15798 -27364 -24204 -20310 29691 -10807 -5487 -31116 29692 10806 15798 -27363 15798 27363 29692 -10806 -5487 31116 29691 10807 -24204 20310 15798 27364 -31597 0 -5486 31116 -7576 -6356zm59126 -73503c71,402 138,805 203,1209 6709,41950 -21859,81397 -63809,88107 4116,-1871 6486,-6009 6306,-10265l7854 6591 5964 -33822 34344 0 -17172 -29743 26310 -22077zm-26309 -45569c13400,11234 23052,27062 26309,45569l-32274 -11746 5965 -33823zm-125404 71076c-6709,-41950 21859,-81397 63809,-88107 22924,-3666 45100,3201 61595,17031l-32274 11747 -17172 -29743 -17172 29743 -32273 -11747 5964 33823 -32274 11746 26310 22077 -17172 29743 34344 0 5964 33822 7857 -6593c-188,4387 2305,8449 6303,10267 -32822,-5250 -58559,-30987 -63809,-63809zm69789 43236l6169 -5177 6169 5177 -12338 0zm-1523 3077l15384 0c4249,0 7693,3444 7693,7692 0,4248 -3444,7692 -7693,7692l-15384 0c-4249,0 -7693,-3444 -7693,-7692 0,-4248 3444,-7692 7693,-7692zm87692 -58462c0,-44183 -35817,-80000 -80000,-80000 -44183,0 -80000,35817 -80000,80000 0,44183 35817,80000 80000,80000 44183,0 80000,-35817 80000,-80000z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    stroke: "#634D16",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    points: "83207,150820 83207,140380 80727,140380 76793,142513 78193,144940 80047,143940 80047,150820 "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg07Diamond01);
export default __webpack_public_path__ + "static/media/07_Diamond_01.2c045217f28135798628a870a90ca097.svg";
export { ForwardRef as ReactComponent };